// Timezone helpers for consistent local-date handling in America/Chicago

const CHICAGO_TZ = 'America/Chicago';

export const formatLocalYMD = (date) => {
  // date can be Date or ISO string
  const d = typeof date === 'string' ? new Date(date) : date;
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: CHICAGO_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).formatToParts(d);
  const y = parts.find(p => p.type === 'year').value;
  const m = parts.find(p => p.type === 'month').value;
  const day = parts.find(p => p.type === 'day').value;
  return `${y}-${m}-${day}`;
};

export const getLocalHours = (date) => {
  const d = typeof date === 'string' ? new Date(date) : date;
  // Use formatter to extract hour in 24h for the timezone
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: CHICAGO_TZ,
    hour: '2-digit',
    hour12: false
  }).formatToParts(d);
  return parseInt(parts.find(p => p.type === 'hour').value, 10);
};

export const nowLocalYMD = () => formatLocalYMD(new Date());

export const addDaysLocalYMD = (date, days) => {
  const d = typeof date === 'string' ? new Date(date) : date;
  const ms = d.getTime() + days * 24 * 60 * 60 * 1000;
  return formatLocalYMD(new Date(ms));
};

export const CHICAGO_TIMEZONE = CHICAGO_TZ;

/**
 * Converts a Chicago local date/time to UTC ISO string
 * @param {string} dateStr - Date in YYYY-MM-DD format
 * @param {string} timeStr - Time in HH:MM format (24-hour)
 * @returns {string} ISO string in UTC (e.g., "2025-10-13T05:30:00.000Z")
 */
export const chicagoToUTC = (dateStr, timeStr) => {
  // Create a date string that represents the Chicago time
  // We'll use the fact that Date.parse with ISO format + timezone works correctly

  // First, determine if DST is in effect for this date in Chicago
  // Create a test date for this day at noon Chicago time
  const testDate = new Date(`${dateStr}T12:00:00`);

  // Format it as Chicago time and check the offset
  const chicagoFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: CHICAGO_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZoneName: 'short'
  });

  const formatted = chicagoFormatter.format(testDate);
  // Format will be like "10/13/2025, 12:00:00 CDT" or "...CST"
  const isDST = formatted.includes('CDT');
  const offset = isDST ? '-05:00' : '-06:00';

  // Create the ISO string with Chicago timezone offset
  const isoWithOffset = `${dateStr}T${timeStr}:00${offset}`;

  // Parse and convert to UTC
  const utcDate = new Date(isoWithOffset);

  return utcDate.toISOString();
};


